import styled from 'styled-components';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { ImageIconType, SOCIALS_ICONS, PAYMENTS_ICONS, INTEGRATIONS_ICONS } from './imageIcons';
import React, { useContext } from 'react';
import { IGutterAsMarginProps, useGutterAsMarginCss } from '../../fundamentals/spaces/space';
import { useActionCss } from '../../fundamentals/actions';
import { IconSize, DEFAULT_ICON_SIZE } from '../Icon/Icon';
import { useGreyscaleCss } from '../../fundamentals/colours/filter';
import { EoraAssetsContext } from '../../themes/EoraThemeProvider';
import { BaseImg } from '../../common/BaseElements';

export interface IImageIconProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'name'>, IGutterAsMarginProps {
  name: ImageIconType;
  size?: IconSize;
  greyScale?: boolean;
}
const DEFAULT_ICON = SOCIALS_ICONS.Github;

export const ImageIcon = styled(BaseImg).attrs<IImageIconProps>(({ name, onClick, greyScale, ...rest }) => {
  const allKeys = new Set([...Object.values(SOCIALS_ICONS), ...Object.values(PAYMENTS_ICONS), ...Object.values(INTEGRATIONS_ICONS)]);
  let iconName = allKeys.has(name) ? name : DEFAULT_ICON;
  const greyPrepend = `grey`;

  let skipGreyScale = iconName.endsWith(greyPrepend);
  const { baseAssetsUrl } = useContext(EoraAssetsContext);

  const { generateTestId } = useTestId(rest, `ImageIcon${iconName}`);

  if (greyScale && allKeys.has(`${name}-${greyPrepend}` as ImageIconType)) {
    skipGreyScale = true;
    iconName = `${name}-${greyPrepend}` as ImageIconType;
  }

  let icon = `${baseAssetsUrl}/images/i/c/${iconName.replace('-', '/')}.svg`;

  return {
    src: icon,
    greyScale: !skipGreyScale && greyScale,
    ...generateTestId(),
    name: undefined
  };
})<IImageIconProps>`
  height: ${({ theme, size = DEFAULT_ICON_SIZE }) => theme.sizes[size]};
  ${useActionCss};
  ${useGutterAsMarginCss()};
  ${({ greyScale }) => greyScale && useGreyscaleCss()}
`;
